<div class="main-content">
  <div class="container-fluid">
    <h3>EPE Application</h3>
    <p class="text-muted">Completa il form per candidarti come Expert Panel Evaluator.</p>

    <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Organizzazione *</label>
            <input type="text" class="form-control" formControlName="organisation">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Tipo Organizzazione *</label>
            <input type="text" class="form-control" formControlName="organisation_type">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Paese *</label>
            <input type="text" class="form-control" formControlName="country">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Genere</label>
            <select class="form-control" formControlName="gender">
              <option value="">-- Seleziona --</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
              <option value="prefer_not_to_say">Prefer not to say</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Titolo</label>
            <input type="text" class="form-control" formControlName="title">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Posizione attuale</label>
            <input type="text" class="form-control" formControlName="position">
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>LinkedIn</label>
        <input type="url" class="form-control" formControlName="linkedin">
      </div>
      <div class="form-group">
        <label>CV (link o descrizione)</label>
        <textarea class="form-control" rows="3" formControlName="cv"></textarea>
      </div>
      <div class="form-group">
        <label>Descrivi la tua esperienza</label>
        <textarea class="form-control" rows="5" formControlName="tell_us_more"></textarea>
      </div>
      <div class="form-group">
        <label>
          <input type="checkbox" formControlName="website_publication">
          Acconsento alla pubblicazione sul sito
        </label>
      </div>

      <button type="submit" class="btn btn-primary" [disabled]="form.invalid || submitting">
        <span *ngIf="submitting"><i class="fa fa-spinner fa-spin"></i> Invio...</span>
        <span *ngIf="!submitting">Invia Application</span>
      </button>
      <a routerLink="/my-applications" class="btn btn-default" style="margin-left: 8px">Annulla</a>
    </form>
  </div>
</div>
